// import ScoreCardTable from "components/Result/AntheResults/resultTable/score-card-table";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { extractQueryParams } from "../utils/getAllURLParameters";
import { decodeBase64Url } from "../utilFunction/decodeUtils";
import Akthelogo from "../assets/akthe_logo_2025.png";
import AntheLogo1 from "../assets/antheLogo1.png";
import AntheLogo2 from "../assets/antheLogo2.png";
import styles from "./anthe.module.css";
import callIcon from "../assets/call.png";
import IACSTTest from "../assets/iacst-test-details-2023.png";
import IacstHighlights from "../assets/iacst-highlights-2023.png";
import airBadge from "../assets/air_badge.png";
import stateBadge from "../assets/state_badge.png";
import config from "../config";
import branchGrade from "../assets/branch-grade.png"
import Antheheading from '../assets/antheseniorjunior.svg'
// import AB443 from "../assets/qrcode-images/AB443.jpg";
import Kashmirtext from '../assets/Kashmor_text.png'
import AktheCA10 from '../assets/akthe_CA_10.png'
import AKTHECA789 from '../assets/akthe_CA_789.png'
import AKTHECA1112 from '../assets/akthe_CA_1112.png'
import Akthebadge from '../assets/Akthe_Badge.png'

function AntheResultPage1_NotQualified({ isStudentPDF = false, Response }) {
  const [decodedData, setDecodedData] = useState(null);
  const imagePath = `/static/media/${Response.profile.branch_id}.jpg`;
  const contacts = Response.centerData.center_detail.contact_numbers;

  // Initialize an empty string to store the formatted output
  let formattedOutput = "";
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedUrl = urlParams.get("data");

    if (encodedUrl) {
      const decodedData = decodeBase64Url(encodedUrl);
      decodedData.exam_type = decodedData.exam_type || "ANTHE";
      setDecodedData(decodedData);
      document.title =
        decodedData.exam_type === "AKTHE" ? "AKTHE Result" : "ANTHE Result";
    }

    // eslint-disable-next-line
  }, []);
  // Iterate through the array, grouping two indexes per line
  for (let i = 0; i < contacts.length; i += 2) {
    const firstContact = contacts[i];
    const secondContact = contacts[i + 1];

    // Check if the second contact exists (it may be undefined if there are an odd number of elements)
    if (secondContact !== undefined) {
      formattedOutput += `${firstContact}, ${secondContact}\n`;
    } else {
      formattedOutput += `${firstContact}\n`;
    }
  }
  return (
    <div style={{ fontFamily: "Outfit-Regular" }}>
      <div className="mx-auto">
        <Row className="bg-dark-blue p-4  mb-3">
          <Col xs={3}>
            {decodedData?.exam_type === "AKTHE" ? (
              <img width="100%" src={Akthelogo} alt="anthe logo - akthe" />
            ) : (
              <img width="100%" src={AntheLogo2} alt="anthe logo - default" />
            )}
          </Col>
          <Col
            className="align-self-center text-start"
            xs={7}
            style={{ padding: "5%", lineHeight: "1.2" }}
          >
            {!Response?.profile?.anthetwo ? (
              <>
                <p
                  className=" font-size-sm font-size-lg-45 font-size-xl-45"
                  style={{
                    // fontSize: '45px',
                    fontWeight: "500",
                    fontFamily: "Outfit-Regular",
                    margin: 0,
                    color: "white",
                  }}
                >
                  Aakash National
                </p>
                <p
                  className={`${styles.page1_cardHeading_2} font-size-xl font-size-lg-60 font-size-xl-60 }`}
                >
                  Talent Hunt Exam
                </p>
                {
                 decodedData?.exam_type === 'AKTHE' ? <p className=""><img src={Kashmirtext} alt="text" width="40%" /></p> : ""
                }
              </>
            ) : (
              <img src={Antheheading} alt="heading" width={"80%"} />
            )}
          </Col>
          <Col xs={2} className="text-center">
            <img width={"100%"} src={AntheLogo1} alt="anthe logo" />
          </Col>
        </Row>
        <div className="mx-5 mt-2">
          {!isStudentPDF && (
            <>
              <Row>
                <Col className="text-start mt-1 fw-lighter font-size-xl">
                  {Response?.scholarship?.remarks}
                </Col>
              </Row>
              <Row className="mt-3 p-0 w-100 m-auto">
                <div
                  className={`${styles.page1_ResultHead}  p-2 bg-dark-blue w-100 text-center text-white font-size-xxl`}
                >
                  RESULT
                </div>
                <Row className="w-100 m-auto p-0">
                  <Col
                    className={`${styles.page1_tableHead} dashed-borderLeft font-size-xl text-center fw-bold`}
                  >
                    {"FOR CLASS " +
                      Response.profile.class_studying +
                      " STUDYING STUDENT"}
                  </Col>
                  <Col
                    className={`${styles.page1_tableHead} dashed-borderLeft dashed-borderRight font-size-xl text-center fw-bold`}
                  >
                    DETAILS OF ANTHE-{config.YEAR} SCORECARD
                  </Col>
                </Row>
              </Row>
              <Row
                className="w-100 m-auto dashed-border p-0"
                style={{
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <Col
                  lg={6}
                  className="d-flex p-0 dashed-borderRight dashed-borderBottom"
                >
                  <Col
                    className={`${styles.page1_tableColumn} dashed-borderRight font-size-xl text-start `}
                  >
                    <Col className="ps-4 fw-bold">Roll No.</Col>
                    <Col className={`${`${styles.page1_highlightedText} ps-4 fw-bold`}`}> PSID </Col>
                    <Col
                      className="ps-4 fw-bold"
                    >
                      Name of Candidate
                    </Col>
                     {decodedData?.exam_type !== "ANTHE" && (
                    <Col className={`${`${styles.page1_highlightedText} ps-4 fw-bold`}`}>Father's Name</Col>
                     )}
                    <Col
                      className={`ps-4 fw-bold ${
                        decodedData?.exam_type === "ANTHE" ? styles.page1_highlightedText : ""
                      }`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Stream / Class Opted{" "}
                    </Col>
                  </Col>
                  <Col
                    className={`${styles.page1_tableColumn} font-size-xl text-center `}
                  >
                    <Col
                      className="text-start ps-3"
                      style={{ whiteSpace: "nowrap", height: "66px" }}
                    >
                      {" "}
                      {Response.profile.roll_number}
                    </Col>
                    <Col className={`${`${styles.page1_highlightedText} text-start ps-3`}`} style={{ height: "66px" }}>
                      {(Response.profile.psId ? Response.profile.psId : "NA")}
                    </Col>
                    <Col
                      className="text-start ps-3" style={{ height: "66px" }}
                    >
                      {Response.profile.name}
                    </Col>
                     {decodedData?.exam_type !== "ANTHE" && (
                    <Col className={`${`${styles.page1_highlightedText} text-start ps-3`}`}>
                      {Response.profile.father_name}
                    </Col>
                     )}
                    <Col
                       className={`text-start ps-3 ${
                        decodedData?.exam_type === "ANTHE" ? styles.page1_highlightedText : ""
                      }`}
                      style={{ whiteSpace: "nowrap", height: "66px" }}
                    >
                      {(Response.profile.stream === 'SOF'
                        ? 'Foundation'
                        : (Response.profile.stream === 'SOM'
                          ? 'Medical'
                          : 'Engineering')
                      ) + " : Class " + Response.profile.class_opted
                      }
                    </Col>
                  </Col>
                </Col>
                <Col lg={6} className="d-flex p-0 dashed-borderBottom">
                  <Col className="d-flex p-0">
                    <Col
                      className={`${styles.page1_tableColumn} dashed-borderRight font-size-lg text-start lh-md_max fw-bold`}
                    >
                      <Col className="ps-3 dashed-borderBottom p-2">
                        Your Grade
                      </Col>
                      <Col className="ps-3 dashed-borderBottom p-2">
                        Your Scholarship Percentage
                      </Col>
                      {/* <Col className="ps-4">Percentage</Col> */}
                        {decodedData?.exam_type === "AKTHE" ? (
                          // For AKTHE: Only show AIR rank
                          <Col
                            style={{ whiteSpace: "nowrap", height: "200px" }}
                            className={`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2 pb-3`}
                          >
                            <img className="me-2" src={Akthebadge} width={20} />
                            {"ANTHE Rank (Kashmir)"}
                          </Col>
                        ) : (
                      <>
                      <Col
                        style={{ whiteSpace: "nowrap" }}
                        className={`${`${styles.page1_highlightedText} ps-4 d-flex align-items-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                      >
                        <img className="me-2" src={stateBadge} width={20} />
                        {"ANTHE Rank (" + Response?.scholarship?.city + ")"}
                      </Col>
                      <Col
                        style={{ whiteSpace: "nowrap" }}
                        className={`${`${styles.page1_highlightedText} ps-4 d-flex align-items-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                      >
                        <img className="me-2" src={stateBadge} width={20} />
                        {"ANTHE Rank (" + Response?.profile?.state + ")"}
                      </Col>
                      <Col
                        style={{ whiteSpace: "nowrap" }}
                        className={`${`${styles.page1_highlightedText} ps-4 d-flex align-items-center text-dark-blue-200 p-2 pb-3`}`}
                      >
                        <img className="me-2" src={airBadge} width={20} />
                        All India ANTHE Rank
                      </Col>
                      </>
                      )}
                    </Col>
                    <Col
                      className={`${styles.page1_tableColumn} font-size-xl text-center lh-md_max fw-bold`}
                    >
                      <Col style={{ lineHeight: "51px", height: "65px" }} className="dashed-borderBottom p-1 pb-2 ps-4">
                        {Response?.grade || '--'}
                      </Col>
                      <Col style={{ lineHeight: "57px", height: "65px" }} className="dashed-borderBottom p-1 ps-4">
                        {Response?.scholarship?.status}*
                      </Col>
                      {/* <Col>{Response?.percentage}</Col> */}
                      {decodedData?.exam_type === "AKTHE" ? (
                          // For AKTHE: Only show AIR rank
                          <Col
                            style={{ lineHeight: "176px", height: "200px" }}
                            className={`${`${styles.page1_highlightedText} text-dark-blue-200 align-items-center p-1 dashed-borderBottom`}`}
                          >
                             {Response.scholarship.stateRank || "--"}
                          </Col>
                        ) : (
                      <>
                      <Col style={{ lineHeight: "48px", height: "65px" }}
                        className={`${`${styles.page1_highlightedText} text-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                      >
                        {Response?.scholarship?.cityRank != "null" ? Response.scholarship.cityRank : "--"}
                      </Col>
                      <Col style={{ lineHeight: "49px", height: "65px" }}
                        className={`${`${styles.page1_highlightedText} text-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                      >
                        {Response?.scholarship?.stateRank || "--"}
                      </Col>
                      <Col style={{ lineHeight: "66px", height: "65px" }}
                        className={`${`${styles.page1_highlightedText} text-center text-dark-blue-200 `}`}
                      >
                        {Response?.scholarship?.allIndiaRank || "--"}
                      </Col>
                      </>
                        )}
                    </Col>
                  </Col>
                </Col>
                {/* {!isStudentPDF && (
                <Col
                  lg={12}
                  className="d-flex p-0 bg-light-yellow rounded-10px m-2 flex-column p-3"
                  // style={{ width: "-webkit-fill-available" }}
                >
                  <Col
                    className={`${styles.page1_tableBottomText} fw-lighter text-dark-blue-200 font-size-xxl text-center`}
                  >
                   You are NOT eligible for ANTHE scholarship however, eligible for iACST
                  </Col>
                </Col>
              )} */}
              </Row>
              <Row>
                <Col ><img src={branchGrade} alt="branchgrade" className="img-fluid" /></Col>
                <Col
                  lg={12}
                  className="d-flex p-0 bg-light-yellow rounded-10px m-2 flex-column p-1 pb-1"
                // style={{ width: "-webkit-fill-available" }}
                >
                  <Col
                    className={`${styles.page1_tableBottomText} fw-lighter text-dark-blue-200 font-size-xxl text-center`}
                  >
                    {decodedData?.exam_type === "AKTHE" ? "You are NOT eligible for ANTHE Kashmir scholarship however, eligible for iACST" : "You are NOT eligible for ANTHE scholarship however, eligible for iACST"}
                  </Col>
                </Col>
               {decodedData?.exam_type === "AKTHE" ? (
              <Col>
                <p className="text-start mb-0 font-size-sm">
                  * For a student with State Rank 150 or below, the scholarship is applicable for Aakash centres in the mentioned state only. However, if such student wishes to take admission in any other State, the scholarship will be offered based on the Grade / Percentile, for which the student can connect with the centre for more information.
                </p>
                <p className="text-start mb-0 font-size-sm">
                  * Applicable as per the Scholarship Slabs published on&nbsp;
                  <a
                    href="https://anthe.aakash.ac.in/anthe-kashmir/terms-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://anthe.aakash.ac.in/anthe-kashmir/terms-conditions
                  </a>
                </p>
                <p className="text-start mb-0 font-size-sm">
                  ** As per the guidelines specified in the ANTHE {config.YEAR}{decodedData?.exam_type === "AKTHE" ? "-Kashmir" : ""} Brochure.
                </p>
              </Col>
            ) : (
              <Col>
                <p className="text-start mb-0 font-size-sm">
                  * For a student with State Rank 150 or below, the scholarship is applicable for Aakash branches in the mentioned state only. However, if such student wishes to take admission in any other State, the scholarship will be offered based on the Grade / Percentile, for which the student can connect with the Branch for more information.
                </p>
                <p className="text-start mb-0 font-size-sm">
                  * Applicable as per the Scholarship Slabs published on&nbsp;
                  <a
                    href={`https://anthe.aakash.ac.in/${Response?.profile?.anthetwo ? "anthe-2" : "anthe"}/terms-conditions`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://anthe.aakash.ac.in/{Response?.profile?.anthetwo ? "anthe-2" : "anthe"}/terms-conditions
                  </a>
                </p>
                <p className="text-start mb-0 font-size-sm">

                  ** As per the guidelines specified in the ANTHE {config.YEAR}{decodedData?.exam_type === "AKTHE" ? "-Kashmir" : ""} Brochure.
                </p>
                <p className="text-start mb-0 font-size-sm">**By viewing this result, you (or your parent/guardian, if you are under 18) hereby provide consent to AESL to contact you via phone, email, SMS, or other communication channels for the purpose of sharing information, updates, and promotional material related to our services until 31st July 2026. You have the right to withdraw your consent at any time by contacting us at <a className='text-decoration-none' href='mailto:care@aesl.in'>care@aesl.in</a>.</p>
              </Col>
            )}
              </Row>
            </>
          )}

          {isStudentPDF && (
            <>
              <Row className=" mt-3 ">
                <Col
                  lg={12}
                  className="d-flex p-0 bg-light-yellow rounded-12px m-2 flex-column p-3 pb-5 px-4 align-items-center"
                // style={{ width: "-webkit-fill-available" }}
                >
                  <Col
                    className={`${styles.page1_tableBottomText} fw-lighter text-dark-blue-200 font-size-3xl my-4 text-center`}
                  >
                    You are not eligible for ANTHE scholarship.
                  </Col>
                  <Col
                    className="text-center fw-lighter font-size-xl"
                    style={{ letterSpacing: "0.8px", fontFamily: "Outfit-Light" }}
                  >
                    We think you weren't prepared for the ANTHE {config.YEAR} scholarship
                    test. We would recommend that you prepare for
                    <span
                      style={{ fontFamily: "Outfit-Medium", fontWeight: "bold" }}
                    >
                      {" "}
                      Instant Admission cum Scholarship Test (iACST)
                    </span>{" "}
                    and get a chance to score{" "}
                    <span
                      style={{ fontFamily: "Outfit-Medium", fontWeight: "bold" }}
                    >
                      upto 90% scholarship.
                    </span>{" "}
                    Visit iacst.aakash.ac.in OR nearest branch/Centre for more
                    details.
                  </Col>
                  <Col
                    lg={12}
                    className="d-flex bg-white rounded-10px p-4 mx-4 mt-3 text-start w-95"
                  >
                    <Col
                      lg={5}
                      className="m-2 pe-2"
                      style={{ borderRight: "1px solid" }}
                    >
                      <Col
                        className={`${styles.page1_addressHeading} font-size-28`}
                      >
                        Branch Address :
                      </Col>
                      <Col className="font-size-lg fw-bold">
                        {Response.centerData.center_detail.address}
                      </Col>
                    </Col>
                    <Col lg={5} className="m-2 ms-3">
                      <Col
                        className={`${styles.page1_addressHeading} font-size-28`}
                      >
                        Branch / Center Contact :
                      </Col>
                      <Col
                        sm={10}
                        className="font-size-lg fw-bold"
                        style={{ letterSpacing: "1px", lineHeight: "2rem" }}
                      >
                        {formattedOutput}
                      </Col>
                    </Col>
                    <Col
                      lg={3}
                      className="flex-column
                    justify-content-center d-flex"
                      style={{
                        position: "relative",
                        right: "1rem",
                        height: "10rem",
                        // top: "43rem",
                      }}
                    >
                      <Col>
                        <img
                          style={{ width: "45%" }}
                          width={100}
                          src={Response?.centerData?.center_detail?.qr_code}
                        />
                      </Col>
                      <Col className="font-size-xs w-5 ps-3">
                        Scan the QR code and get the branch location in your
                        Google Maps
                      </Col>
                    </Col>
                  </Col>
                </Col>
              </Row>
            </>
          )}
          <Row>
            <div className="pt-1">
              <img
                src={IACSTTest}
                className="mx-auto d-flex img-fluid mb-4 my-2 w-100"
              />
              <img
                src={IacstHighlights}
                className="mx-auto d-flex img-fluid my-2 w-100 mb-2"
              />
            </div>
          </Row>
          <Row
            className="d-flex flex-row-reverse"
          // style={{ position: "relative", top: "7rem" }}
          >
              <Col lg={10} className="p-0">
              <hr />
              <Col lg={12} className="d-flex">
                <Col className="dashed-borderRight font-size-sm me-1 pe-2 text-end">
                  <b>Corporate Office:</b> 3rd Floor, Incuspaze Campus – 2, Plot No. 13, Sector – 18, Udyog Vihar, Gurugram, Haryana - 122015
                  <br />
                  <b>Ph.:</b> +91-11–47623456 | <b>E-mail:</b> care@aesl.in
                </Col>
                <Col lg={3} className="d-flex justify-content-start ms-1">
                  <Col lg={2} className="me-3">
                    <img width={50} src={callIcon} />
                  </Col>
                  <Col className="d-flex flex-column text-start">
                    <span className="font-size-xs">TOLL FREE NUMBER </span>
                    <b className="font-size-xxl">1800-102-2727</b>
                  </Col>
                </Col>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default AntheResultPage1_NotQualified;